/**
 * Bento-style info card used to lay out sun / companion / keystone / pests
 * blocks on the Result page. Consistent border, padding, and header type.
 *
 * `trailing` renders in the top-right of the header, aligned with the title —
 * used for small per-card actions like "regenerate" without introducing a
 * second nested card.
 */
export const InfoCard = ({ title, icon, children, testId, trailing }) => (
  <div data-testid={testId} className="bg-white rounded-3xl border border-[#E8E5DF] p-5">
    <div className="flex items-center gap-2 text-leaf">
      {icon}
      <h2 className="text-xs uppercase tracking-[0.18em] font-medium">{title}</h2>
      {trailing ? <div className="ml-auto flex items-center">{trailing}</div> : null}
    </div>
    <div className="mt-3 text-leaf-ink text-[15px] leading-relaxed">{children}</div>
  </div>
);

export default InfoCard;
